import { memo } from 'react'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import { CURRENCY } from '@/constants'
import { useGetWalletAssets } from '@/hooks/wallet'
import { useLocation } from 'react-router'

const Overview = () => {
  const { t } = useTranslation()
  const location = useLocation()

  const {
    totalAssets,
    changedAmount,
    appAssets,
    appAssetsPercent,
    apiAssets,
    apiAssetsPercent,
    changedAmountPercent,
  } = useGetWalletAssets(location.search.slice(1).split('&')[0])

  return (
    <div className={styles.container}>
      <div className={styles.detailCard}>
        <div className={styles.totalCard}>
          <h3>{t('wallet.home.totalAssets', { currency: CURRENCY })}</h3>
          <p>$ {totalAssets}</p>
          <div>
            <span className={styles.label}>{t('common.today')}</span>
            <span>{changedAmountPercent}</span>
            <span>
              ({changedAmount} {CURRENCY})
            </span>
          </div>
        </div>
        <div className={styles.appCard}>
          <h3>{t('wallet.home.appAssets', { currency: CURRENCY })}</h3>
          <p>$ {appAssets}</p>
          <div>
            <span className={styles.label}>{t('wallet.home.assetsRatio')}</span>
            <span>{appAssetsPercent}%</span>
          </div>
        </div>
        <div className={styles.apiCard}>
          <h3>{t('wallet.home.apiAssets', { currency: CURRENCY })}</h3>
          <p>$ {apiAssets}</p>
          <div>
            <span className={styles.label}>{t('wallet.home.assetsRatio')}</span>
            <span>{apiAssetsPercent}%</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(Overview)
